import Popup from '../../../../../components/Popup/Popup'
import { Button, BUTTON_TYPES } from '../../../../../components/Button'
import { BTN_TXT } from '../../../../../constants'
import {
  Typography,
  TYPOGRAPHY_WEIGHT
} from '../../../../../components/Typography'

export const SaveChangesPopup = ({
  hsName,
  open,
  onSave,
  onCancel,
  departmentsRemoved
}: {
  hsName: string
  open: boolean
  onSave: () => void
  onCancel: () => void
  departmentsRemoved?: boolean
}) => {
  return (
    <Popup
      visible={open}
      onCancel={onCancel}
      title={'Save changes to Health System?'}
      width={442}
      footer={
        <>
          <Button onClick={onCancel} type={BUTTON_TYPES.DEFAULT} upperCase>
            {BTN_TXT.CANCEL}
          </Button>
          <Button type={BUTTON_TYPES.PRIMARY} upperCase onClick={onSave}>
            {BTN_TXT.SAVE}
          </Button>
        </>
      }
    >
      <Typography.Headline6 weight={TYPOGRAPHY_WEIGHT.NORMAL}>
        All changes will be applied to {hsName} Health System and the related
        Hospitals and users.
      </Typography.Headline6>
      {departmentsRemoved && (
        <Typography.Headline6 weight={TYPOGRAPHY_WEIGHT.NORMAL}>
          Departments removed at the Health System level will also be
          automatically deleted from Hospital records.
        </Typography.Headline6>
      )}
    </Popup>
  )
}
